import React, { useEffect, useState } from 'react';
import { StyledEntryStatus } from './style';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, ChartOptions, ChartData } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { useRecoilValue } from 'recoil';
import {
  ChartDashboardCompanyDirectMPAtom,
  ChartDashboardTodayEntryAtom
} from '../../../../../modules/dashboard';

ChartJS.register(ArcElement, Tooltip, Legend);

// 가운데 텍스트 플러그인

interface IProps {
  test?: string;
  data: any;
}

export const EntryStatus: React.FC<IProps> = (props) => {
  const todayEntryData = useRecoilValue(ChartDashboardTodayEntryAtom);
  const companyDirectMP = useRecoilValue(ChartDashboardCompanyDirectMPAtom);
  const formatNumber = (value: number) => value.toLocaleString('ko-KR');
  const color = [
    '#1E3A8A',
    '#2563EB',
    '#38BDF8',
    '#A855F7',
    '#E5E7EB',
    '#E5E7EB',
    '#E5E7EB',
    '#E5E7EB',
    '#E5E7EB'
  ];

  const [drawData, setDrawData] = useState([]);
  useEffect(() => {
    if (props.data?.length === 0) {
      const ds = [
        { label: '-', value1: '-', value2: 1 },
        { label: '-', value1: '-', value2: 1 },
        { label: '-', value1: '-', value2: 1 },
        { label: '-', value1: '-', value2: 1 },
        { label: '-', value1: '-', value2: 1 }
      ];
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      setDrawData(ds);
    }else{
      var total = 0;
      for (var i in props.data) {
        var item = props.data[i];
        total += item.count;
      }
      var ds = [];
      for (var i in props.data) {
        var item = props.data[i];
        var _color = color[+i];
        if (_color === undefined) {
          break;
        }
        ds.push({ label: item.label, value1: item.count, value2: item.subCount });
      }
      //console.log(props.data, total, ds);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      setDrawData(ds);
    }
  }, [props.data]);

  const data: ChartData<'doughnut'> = {
    // 예시 값 (섹터별 값)
    labels: drawData.map((item: any) => item.label),
    datasets: [
      {
        data: drawData.map((item: any) => item.value2),
        backgroundColor: color,
        borderWidth: 0,
        borderRadius: 2, // 각 조각 둥글게
        spacing: 2 // 조각 사이 여유
      }
    ]
  };

  const summeryData = {
    total: 1800,
    workers: 1500
  };

  const centerTextPlugin = {
    id: 'centerTextPlugin',
    afterDraw: (chart: any) => {
      const { ctx, width, height } = chart;

      ctx.save();
      const totalText = `${formatNumber(summeryData.total)} / ${formatNumber(summeryData.workers)}`; /*'1,830 / 1,500'*/
      const subText = 'Workers';

      ctx.font = '600 11px sans-serif';
      ctx.fillStyle = '#2F2F35';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(totalText, width / 2, height / 2 - 6);

      ctx.font = '600 11px sans-serif';
      ctx.fillStyle = '#2F2F35';
      ctx.fillText(subText, width / 2, height / 2 + 12);

      ctx.restore();
    }
  };

  // TODO : 임시제거
  //ChartJS.register(centerTextPlugin);

  const options: ChartOptions<'doughnut'> = {
    responsive: true,
    cutout: '60%', // 안쪽 구멍 크기 (도넛 두께)
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        enabled: true
      }
    }
  };
  return (
    <StyledEntryStatus>
      <div className={'component-title'}>Entry Status</div>
      <div className={'component-body'}>
        <div className={'chart'}>
          <Doughnut data={data} options={options} />
        </div>
        <div className={'item-list'}>
          {drawData.map((item: any, index: number) => (
            <div className={'item'} key={index}>
              <div className={'label'} title={item.label}>
                <div className={'label-icon'} style={{ backgroundColor: color[index] }}></div>
                <div
                  className={'label-text saf-no-wrap'}
                  style={{ overflowX: 'hidden', width: '100px', textOverflow: 'ellipsis' }}
                >
                  {item.label}
                </div>
              </div>
              <div className={'value saf-no-wrap'}>
                {props.data?.length === 0 ? '- / -' : item.value2 + '/' + item.value1}
              </div>
            </div>
          ))}
        </div>
      </div>
    </StyledEntryStatus>
  );
};
